<template>
    <div class="card floating-help rounded-lg w-50">
        <div v-if="isLoading" class="border-left border-success mt-2">
            <b-list-group class="h-25">
                <div v-for="(item, idx) in listItems" :key="idx" :href="item.url" class="align-items-start border-0">
                    <h5 class="container mb-1 h-50">
                        <span class="text-success">{{ "\u2022" }}</span>
                        {{ "&nbsp" + item.name }}
                    </h5>
                </div>

                <div class="container align-items-start border-0">
                    <b-button @click.prevent="openSurveyLink" pill variant="primary" size="sm" style="margin-bottom: 5%; margin-top: 5%;">
                        <h5 class="text-white">Avalie sua Experência!</h5>
                    </b-button>
                </div>
            </b-list-group>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    name: 'HelpCard',

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('booking',{
            form: 'getReservaForm',
        }),
    },

    data() {
        return {
            listItems: [
                { name: "Ajuda", url: "#" }, { name: "FAQ", url: "#" }, { name: "Janoo", url: "#" },
                { name: "Contato", url: "#" }, { name: "Registro de ocorrência", url: "#" },
            ]
        }
    },

    methods: {
        openSurveyLink(){
            const link = this.form.atrativo.link_nps
            window.open(link, '_blank').focus();
        }
    },

}
</script>

<style scoped>
.floating-help {
    /* position: fixed; */
    /* top: 10px; */
    left: 10px;
    /* z-index: 1000; */
}
</style>